export default __webpack_public_path__ + "static/media/trashRed.607318bc.svg";